module.exports = __webpack_public_path__ + "img/logo.47546bcb.png";